import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpHeaderLogoTitleComponent from './adpHeaderLogoTitle.component';

let adpHeaderLogoTitleModule = angular.module('adpHeaderLogoTitle', [
  uiRouter
])

.component('adpHeaderLogoTitle', adpHeaderLogoTitleComponent)

.name;

export default adpHeaderLogoTitleModule;



// WEBPACK FOOTER //
// ./src/app/components/adpHeaderLogoTitle/adpHeaderLogoTitle.js